const placeholderReplaceRegex = /({[^}]+})/g;
export default (value, args) => value &&
    value.replace(placeholderReplaceRegex, ph => {
        const key = ph.substr(1, ph.length - 2).trim();
        if (key in args) {
            const val = args[key];
            if (val == null) {
                return '';
            }
            else if (typeof val === 'number') {
                return val.toString();
            }
            else {
                return val;
            }
        }
        else {
            console.error('Could not find placeholder', key, 'in', args);
            return ph;
        }
    });
